/**
 * Whether `redirect` query/path is a safe in-app post-login destination.
 * Rejects absolute/protocol-relative URLs and the login page itself (redirect loop).
 * @param {unknown} redirectTarget
 * @returns {boolean}
 */
export const isSafePostLoginRedirect = redirectTarget => {
  if (typeof redirectTarget !== 'string') return false
  if (!redirectTarget.startsWith('/') || redirectTarget.startsWith('//')) return false

  const pathname = redirectTarget.split(/[?#]/)[0]
  if (pathname === '/login' || pathname === '/login/') return false

  return true
}
